import React from 'react';
import type { SignupFlow } from 'corgi-types';

import { Link } from 'common/components/Link';
import { LinkRegularLR2 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import { Event } from 'common/types/auth';
import { getUserFlowQueryParam } from 'common/utils/signup';

interface ForgotPasswordLinkProps {
  userFlow: SignupFlow;
}

const ForgotPasswordLink = ({ userFlow }: ForgotPasswordLinkProps) => {
  const { t } = useLocalization();
  const text = t('h24_login_form_forgot_password');

  return (
    <LinkRegularLR2 color="sys.neutral.text.strong" textDecoration="underline">
      <Link
        href={`./forgotpassword${getUserFlowQueryParam(userFlow)}`}
        tracking={{
          eventName: Event.LoginFormClick,
          text,
        }}
      >
        {text}
      </Link>
    </LinkRegularLR2>
  );
};

export default ForgotPasswordLink;
